import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { GrupoUnidadMedidaInputProps, GrupoUnidadMedidaProp } from '../interfaces'
import { MyGraphQlError } from '../../../base/services/GraphqlError'

const gqlQuery = gql`
  mutation GRUPO_MEDIDA_REGISTRO($input: GrupoUnidadMedidaInput!) {
    grupoUnidadMedidaRegistro(input: $input) {
      _id
    }
  }
`

export const apiGrupoUnidadMedidaRegistro = async (
  input: GrupoUnidadMedidaInputProps,
): Promise<GrupoUnidadMedidaProp> => {
  const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  // Set a single header
  client.setHeader('authorization', `Bearer ${token}`)
  try {
    const data: any = await client.request(gqlQuery, {
      input: input,
    })
    return data.grupoUnidadMedidaRegistro
  } catch (error) {
    throw new MyGraphQlError(error as any)
  }
}
